import consumer from '../channels/consumer';
import { Controller } from '@hotwired/stimulus';

export default class DashboardChartsController extends Controller {
  static targets = ['skeleton'];

  static values = {
    profileId: String,
    tab: String,
    errorMessage: String,
  };

  connect() {
    const skeleton = this.skeletonTarget;
    this.requestChartsData(skeleton);

    this.initSelect2();
  }

  requestChartsData(skeleton) {
    const subscription = consumer.subscriptions.create(
      {
        channel: 'DashboardChartsChannel',
        profile_id: this.profileIdValue,
        tab: this.tabValue,
      },
      {
        received: (data) => {
          if (data.status === 'success') {
            skeleton.innerHTML = data.html;
            this.initSelect2();
          } else {
            toastr.error(this.errorMessageValue);
          }
          subscription.unsubscribe();
        },
        disconnected: () => {
          subscription.unsubscribe();
        },
      }
    );
  }

  initSelect2() {
    $(this.skeletonTarget).find('.form-select').select2({
       minimumResultsForSearch: Infinity,
    });
  }

  disconnect() {
    $(this.skeletonTarget).find('.form-select').select2('destroy');
  }
}
